import { render, staticRenderFns } from "./carousel-promo.vue?vue&type=template&id=4e3e3bb6&scoped=true&"
import script from "./carousel-promo.vue?vue&type=script&lang=js&"
export * from "./carousel-promo.vue?vue&type=script&lang=js&"
import style0 from "./carousel-promo.vue?vue&type=style&index=0&id=4e3e3bb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3e3bb6",
  null
  
)

export default component.exports